<template>
  <div>
    <div v-if="$getConfigValue('MOSTRAR_ALERTA_BIODATA_CONDUCCION', 'NO') === 'SI'">
      <a-alert
        :message="$getConfigValue('MENSAJE1_ALERTA_CONDUCCION')"
        :description="$getConfigValue('MENSAJE2_ALERTA_CONDUCCION')"
        type="info"
        show-icon
      />
    </div>
    <br>
    <g-master name="biodatalicenciasconduccion"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :modalFieldsSetup="master.modalFieldsSetup"
              :parentData="bioParentData"
              @action="masterAction"
              modalWidth="90%"
              ref="masterComponent"
    >
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Nº. de licencia')">
              <a-input
                class="ant-uppercase"
                v-decorator="['license_number', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions" v-if="mostrarCampoCategoriaComoLista">
            <g-dropdown endpoint="hierarchy_lookup"
                        style="width: 100%"
                        :formItemConfig="fiOptions"
                        :label="$t('Categoría de licencia')"
                        :decorator="['category_license', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                        :params="id_h_category_license">
            </g-dropdown>
          </a-col>
          <a-col v-bind="colOptions" v-else>
            <a-form-item :label="$t('Cat. de licencia')">
              <a-input
                class="ant-uppercase"
                v-decorator="['category_license', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <g-dropdown endpoint="hierarchy_lookup"
                        style="width: 100%"
                        :formItemConfig="fiOptions"
                        :label="$t('Clase de licencia')"
                        :decorator="['id_h_license_class', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                        :params="id_h_license_class">
            </g-dropdown>
          </a-col>
          <a-col v-bind="colOptions">
            <g-dropdown endpoint="hierarchy_lookup"
                        :label="$t('Tipo de licencia')"
                        style="width: 100%"
                        :formItemConfig="fiOptions"
                        :decorator="['id_h_license_type', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                        :params="id_h_license_type">
            </g-dropdown>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('F. de expedición')">
              <a-date-picker style="width: 100%"
                             v-decorator="['expedition_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('F. de expiración')">
              <a-date-picker style="width: 100%"
                             v-decorator="['expiration_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions" v-if="mostrarCampoLugarAut">
            <g-dropdown endpoint="hierarchy_lookup"
                        :label="$t('Lugar de autenticación')"
                        style="width: 100%"
                        :formItemConfig="fiOptions"
                        :decorator="['id_h_auth_place', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                        :params="id_h_auth_place">
            </g-dropdown>
          </a-col>
          <a-col v-bind="colOptions">
            <g-dropdown endpoint="hierarchy_lookup"
                        style="width: 100%"
                        :label="$t('País')"
                        :formItemConfig="fiOptions"
                        :decorator="['id_h_country', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                        :customSlots="['suffixIcon']"
                        :selectedObj.sync="dropdown.country"
                        :params="id_h_country"
                        ref="id_h_country">
              <template slot="suffixIcon">
                <img style="max-width: 20px"
                     :src="flags[dropdown.country.equivalency]"
                     alt=""
                     v-if="dropdown.country && dropdown.country.equivalency">
              </template>
            </g-dropdown>
          </a-col>
          <a-col v-if="mostrarCampoExpiracion" v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Expiración')" :has-feedback="false">
              <a-checkbox v-decorator="['expiration', {valuePropName: 'checked', initialValue: false}]">
              </a-checkbox>
            </a-form-item>
          </a-col>
          <a-col v-if="mostrarCampoAspectoSocial" v-bind="colOptions">
            <a-form-item :label="$t('Aspecto social')">
              <a-input
                class="ant-uppercase"
                v-decorator="['social_aspect', { rules: [{ required: false }] }]"
                :disabled="isDisabledsAspectoSocial"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <g-dropdown endpoint="hierarchy_lookup"
                        :label="$t('Tiene vehículo')"
                        style="width: 100%"
                        :selectedObj.sync="has_vehicle"
                        :formItemConfig="fiOptions"
                        :decorator="['has_vehicle', { rules: [{ required: false, message: 'Valor requerido' }], initalValue: 'S' }]"
                        :params="estado_sn">
            </g-dropdown>
          </a-col>
          <div v-show="has_vehicle.text==='SI'">
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Tipo de vehiculo')"
                          style="width: 100%"
                          :formItemConfig="fiOptions"
                          :decorator="['vehicle_type', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                          :params="vehicle_type">
              </g-dropdown>
            </a-col>
          </div>
        </a-row>
      </template>
    </g-master>
  </div>
</template>
<script>
  import FLAGS from 'CustomModules/GlobalBPOCore/Util/FlagsUtil'
  import JsUtils from '../../../../util/JsUtils'

  export default {
    props: ['persona'],
    computed: {
      bioParentData () {
        return {
          id_person: this.persona
        }
      },
      vehicle_type () {
        if (this.$getConfigValue('TIPO_VEHICULO_GUARDA_ID_H_LOOKUP') === 'NO') {
          return {
            h_lookup_type: 'TIPO_VEHICULO',
            use_description: true
          }
        } else {
          return {
            h_lookup_type: 'TIPO_VEHICULO'
          }
        }
      }
    },
    data () {
      return {
        mostrarCampoExpiracion: this.$getConfigValue('MOSTRAR_BIODATA_CONDUCCION_EXPIRACION') !== 'NO',
        mostrarCampoAspectoSocial: this.$getConfigValue('MOSTRAR_BIODATA_CONDUCCION_ASPECTO_SOCIAL') !== 'NO',
        isDisabledsAspectoSocial: this.$getConfigValue('BIODATA_CONDU_SOCIAL_ASPECT_DISABLED', false) === 'SI',
        mostrarCampoLugarAut: this.$getConfigValue('MOSTRAR_BIODATA_CONDUCCION_LUGAR_AUT') !== 'NO',
        mostrarCampoCategoriaComoLista: this.$getConfigValue('MOSTRAR_BIODATA_CONDUCCION_CATEGORIA_COMO_LISTA', false) === 'SI',
        has_vehicle: {},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        flags: FLAGS,
        dropdown: {
          country: {}
        },
        id_h_auth_place: {
          h_lookup_type: 'LUGAR_AUTORIZADO'
        },
        id_h_country: {
          h_lookup_type: 'PAISES_HV'
        },
        id_h_license_class: {
          h_lookup_type: 'CLASE_LICENCIA'
        },
        id_h_license_type: {
          h_lookup_type: 'TIPO_LICENCIA'
        },
        estado_sn: {
          h_lookup_type: 'ESTADO_SN',
          use_code: true
        },
        id_h_category_license: {
          h_lookup_type: 'CATEGORIA_LICENCIA',
          use_code: true
        },
        colOptions: {xs: 24, sm: 12},
        master: {
          beforeSend: (data) => {
            data.address = this.address
            return data
          },
          endpoint: 'person_driverlic',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Categoría de licencia', dataIndex: 'category_license', sorter: true},
              {title: 'Fecha de expedición', dataIndex: 'expedition_date_desc', sorter: true},
              {title: 'Expiración', dataIndex: 'expiration_desc', sorter: true},
              {title: 'Fecha de expiración', dataIndex: 'expiration_date_desc', sorter: true},
              {title: 'Tiene vehículo', dataIndex: 'has_vehicle_desc', sorter: true},
              {title: 'Lugar de autenticación', dataIndex: 'h_auth_place', sorter: true},
              {title: 'País', dataIndex: 'h_country', sorter: true},
              {title: 'Clase de licencia', dataIndex: 'h_license_class', sorter: true},
              {title: 'Tipo de licencia', dataIndex: 'h_license_type', sorter: true},
              {title: '# Licencia', dataIndex: 'license_number', sorter: true},
              {title: 'Aspecto social', dataIndex: 'social_aspect', sorter: true},
              {title: 'Tipo de vehiculo', dataIndex: 'h_vehicle_type', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'category_license'},
            {name: 'expedition_date', type: 'date'},
            {name: 'expiration'},
            {name: 'expiration_date', type: 'date'},
            {name: 'has_vehicle'},
            {name: 'id_h_auth_place'},
            {name: 'id_h_country'},
            {name: 'id_h_license_class'},
            {name: 'id_h_license_type'},
            {name: 'license_number'},
            {name: 'social_aspect'},
            {name: 'vehicle_type'}
          ]
        }
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'fieldsChange':
            if (Object.keys(action.changedFields).length > 1) {
              break
            }
            if (!JsUtils.isEmpty(action.changedFields.has_vehicle)) {
              if (action.changedFields.has_vehicle.value === 'N') {
                this.$refs.masterComponent.modal.form.setFieldsValue({
                  vehicle_type: null
                })
              }
            }
            break

          case 'masterEdit':
            if (action.record) {
              if (action.record.has_vehicle === 'S') {
                this.has_vehicle = {
                  text: 'SI'
                }
              }
            }
            break
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Biodata/BiodataLicenciasConduccion.vue